export function MarketplaceTitle({ children }: { children: React.ReactNode }) {
  return (
    <h1 className="py-12 md:py-20 text-6xl md:text-8xl font-bold instrument-serif text-center">
      {children}
    </h1>
  );
}

export function MarketplaceBody({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex-1">
      <div className="text-slate-normal min-h-screen mx-auto pb-20 flex flex-col gap-6 md:gap-8">
        {children}
      </div>
    </div>
  );
}
